import type { JackpotCoinType } from './types';

/** `<body>` attribute names the badge stylesheet matches on. */
export const JP_COIN_ATTRIBUTE = 'data-jp-coin';
export const JP_BADGES_ATTRIBUTE = 'data-jp-badges';

/**
 * Publish the Crown Jackpot badge gate to `<body>` for CSS to act on.
 *
 * Split out of the store's autorun so it can be tested without constructing a whole RootStore, and so
 * the two attribute names live next to each other rather than inline in a reaction.
 *
 * - `data-jp-coin` — the coin whose jackpot is live. A tile's badge shows only for a group on this
 *   coin; a game is normally enrolled on both, and the amount beside the badge belongs to one group.
 * - `data-jp-badges` — the global gate: `off` during maintenance, while the widget is hidden, and
 *   before core's widget decision has settled.
 *
 * See `CrownJackpotBadge.module.scss` for the rules that read them, and why the hook is the coin
 * rather than the jackpot id (CSS cannot compare two attribute values).
 */
export const publishJackpotBadgeAttributes = (coinType: JackpotCoinType, canShowBadges: boolean): void => {
  document.body.setAttribute(JP_COIN_ATTRIBUTE, coinType);
  document.body.setAttribute(JP_BADGES_ATTRIBUTE, canShowBadges ? 'on' : 'off');
};
